import * as React from 'react';
import styles from './styles.module.css';
import { UIText1 } from '../../../../typography';
import { clsx as cx } from 'clsx';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var SuggestionTitleItem = /*#__PURE__*/React.forwardRef(function (props, iconRef) {
  return /*#__PURE__*/_jsxs("li", {
    className: cx(styles['item'], styles[props.variant]),
    role: "option",
    tabIndex: -1,
    "data-testid": "suggesttion-title-item",
    children: [props.leftIcon && /*#__PURE__*/_jsx("div", {
      ref: iconRef,
      className: styles['left-icon'],
      children: props.leftIcon
    }), /*#__PURE__*/_jsx("div", {
      className: cx(styles['name'], styles[props.variant]),
      children: /*#__PURE__*/_jsx(UIText1, {
        display: "inline",
        fontWeight: "700",
        children: props.title
      })
    })]
  });
});
SuggestionTitleItem.displayName = 'SuggestionItem';